"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RlayersBase = void 0;
var react_1 = __importDefault(require("react"));
var context_1 = require("./context");
var debug_1 = __importDefault(require("./debug"));
var RlayersBase = (function (_super) {
    __extends(RlayersBase, _super);
    function RlayersBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RlayersBase.prototype.olEventName = function (ev) {
        return ev.substring(2).toLowerCase();
    };
    RlayersBase.prototype.attachEventHandlers = function () {
        var e_1, _a;
        var _this = this;
        var _b, _c;
        var eventSources = (_b = this.eventSources) !== null && _b !== void 0 ? _b : [this.ol];
        var newEvents = Object.keys(this.props).filter(function (p) { return p.startsWith('on'); });
        var eventsToCheck = newEvents.concat(Object.keys((_c = this.handlers) !== null && _c !== void 0 ? _c : {}).filter(function (ev) { return !newEvents.includes(ev); }));
        var _loop_1 = function (p) {
            var e_2, _d, e_3, _e;
            if (this_1.handlers === undefined)
                this_1.handlers = {};
            if (this_1.handlers[p] !== undefined && this_1.props[p] === undefined) {
                debug_1.default('removing previously installed handler', this_1, p, this_1.handlers[p]);
                try {
                    for (var eventSources_1 = (e_2 = void 0, __values(eventSources)), eventSources_1_1 = eventSources_1.next(); !eventSources_1_1.done; eventSources_1_1 = eventSources_1.next()) {
                        var source = eventSources_1_1.value;
                        source.un(this_1.olEventName(p), this_1.handlers[p]);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (eventSources_1_1 && !eventSources_1_1.done && (_d = eventSources_1.return)) _d.call(eventSources_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                this_1.handlers[p] = undefined;
            }
            if (this_1.handlers[p] === undefined && this_1.props[p] !== undefined) {
                debug_1.default('installing handler', this_1, p, this_1.props[p]);
                this_1.handlers[p] = function (e) { return _this.props[p].call(_this, e); };
                try {
                    for (var eventSources_2 = (e_3 = void 0, __values(eventSources)), eventSources_2_1 = eventSources_2.next(); !eventSources_2_1.done; eventSources_2_1 = eventSources_2.next()) {
                        var source = eventSources_2_1.value;
                        source.on(this_1.olEventName(p), this_1.handlers[p]);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (eventSources_2_1 && !eventSources_2_1.done && (_e = eventSources_2.return)) _e.call(eventSources_2);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        };
        var this_1 = this;
        try {
            for (var eventsToCheck_1 = __values(eventsToCheck), eventsToCheck_1_1 = eventsToCheck_1.next(); !eventsToCheck_1_1.done; eventsToCheck_1_1 = eventsToCheck_1.next()) {
                var p = eventsToCheck_1_1.value;
                _loop_1(p);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (eventsToCheck_1_1 && !eventsToCheck_1_1.done && (_a = eventsToCheck_1.return)) _a.call(eventsToCheck_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    RlayersBase.prototype.refresh = function (prevProps) {
        this.attachEventHandlers();
    };
    RlayersBase.prototype.componentDidMount = function () {
        debug_1.default('didMount', this);
        this.refresh();
    };
    RlayersBase.prototype.propsDiff = function (prev) {
        var e_4, _a;
        if (this.props === null || prev === null) {
            if (this.props !== prev) {
                debug_1.default('null props differ', this.props, prev);
                return true;
            }
            return false;
        }
        try {
            for (var _b = __values(Object.keys(this.props)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var k = _c.value;
                if (this.props[k] !== prev[k]) {
                    debug_1.default('because of', k, this.props[k], prev[k]);
                    return true;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return false;
    };
    RlayersBase.prototype.componentDidUpdate = function (prevProps, prev, snap) {
        if (this.props !== prevProps) {
            debug_1.default('willRefresh', this, prevProps, this.props);
            this.refresh(prevProps);
        }
    };
    RlayersBase.prototype.componentWillUnmount = function () {
        var e_5, _a, e_6, _b;
        var _c, _d;
        debug_1.default('willUnmount', this, this.handlers);
        var eventSources = (_c = this.eventSources) !== null && _c !== void 0 ? _c : [this.ol];
        try {
            for (var _e = __values(Object.keys((_d = this.handlers) !== null && _d !== void 0 ? _d : {})), _f = _e.next(); !_f.done; _f = _e.next()) {
                var h = _f.value;
                debug_1.default('cleaning up handler', this, h, this.handlers[h]);
                if (this.handlers[h])
                    try {
                        for (var eventSources_3 = (e_6 = void 0, __values(eventSources)), eventSources_3_1 = eventSources_3.next(); !eventSources_3_1.done; eventSources_3_1 = eventSources_3.next()) {
                            var source = eventSources_3_1.value;
                            source.un(this.olEventName(h), this.handlers[h]);
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (eventSources_3_1 && !eventSources_3_1.done && (_b = eventSources_3.return)) _b.call(eventSources_3);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    RlayersBase.prototype.render = function () {
        return null;
    };
    RlayersBase.contextType = context_1.RContext;
    return RlayersBase;
}(react_1.default.PureComponent));
exports.RlayersBase = RlayersBase;
//# sourceMappingURL=REvent.js.map